import React from "react";
import { Modal, Typography, Button } from "antd";

const { Text } = Typography;

interface WarningModalProps {
  visible: boolean;
  warningMessage: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  onClose?: () => void;
  okText?: string;
  cancelText?: string;
  iconComponent?: any;
  setVisible: any;
}

const WarningModal: React.FC<WarningModalProps> = ({
  visible,
  warningMessage,
  onCancel,
  onConfirm,
  okText = "Continue",
  cancelText = "Cancel",
  setVisible,
  iconComponent,
}) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable={true}
      onCancel={() => {
        setVisible(false);
      }}
      centered
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        {iconComponent}

        <Text
          strong
          style={{ display: "block", fontSize: 16, marginBottom: 24 }}
        >
          {warningMessage}
        </Text>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 12,
            marginTop: 20,
          }}
        >
          {onCancel && <Button onClick={onCancel}>{cancelText}</Button>}

          {onConfirm && (
            <Button type="primary" danger onClick={onConfirm}>
              {okText}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default WarningModal;
